import { render, staticRenderFns } from "./EventBioPanel.vue?vue&type=template&id=a08f7fb0&"
import script from "./EventBioPanel.vue?vue&type=script&lang=js&"
export * from "./EventBioPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports